export default __webpack_public_path__ + "static/media/laponia.0bb61fb8.png";